import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Col, Row, Form } from "antd";
import { Button, Input } from "components/uielements";
import authAction from "../../redux/auth/actions";
import profileAction from "../../redux/profile/actions";
import { Translate } from "components/utility";
import LoginStyleWrapper from "./styles/login.style";
import Api from "api/Api";
import { APP_PATH } from "containers/App/Router/paths";
import notification from "../../components/notification";

const FormItem = Form.Item;
const { login, loginAction } = authAction;
const { get_user } = profileAction;

class Login extends Component {
  state = {
    redirectToReferrer: false,
    loading: false
  };

  componentWillMount() {
    if (this.props.isLoggedIn) {
      this.setState({ redirectToReferrer: true });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        delete Api.defaults.headers.common["Authorization"];
        this.props
          .loginAction(values)
          .then(response => {
            this.props.login(response.data);
            this.props.get_user(response.data.id);
            this.props.history.push(APP_PATH.dashboard);
            // notification("success", "login successful");
          })
          .catch(error => {
            // let response = error.response;
            this.setState({ loading: false });
          });
      }
    });
  };

  loginWithBankID = () => {
    const { loginBankIdUrl, history } = this.props;
    history.push(loginBankIdUrl);
  };
  loginWithMobileBankID = () => {
    this.props.history.push('/qr-login-bankid');
  };
  render() {
    // console.log(this.props.isLoggedIn);
    const from = { pathname: "/dashboard" };
    const { redirectToReferrer, loading } = this.state;
    const { getFieldDecorator } = this.props.form;
    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }
    const { userType } = this.props;
    return (
      <LoginStyleWrapper className="isoLoginPage">
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <div className="isoLogoWrapper">
              <Translate id={"page.loginTitle"} />
            </div>
            {
              userType === 2 ?
                <div className="loginCreateAccount">
                  <Translate id={"page.loginCreateAccount"} />
                  &nbsp;
                  <Link to="/registration">
                    <Translate id={"page.loginCreateAccountTitle"} />
                  </Link>
                </div>
                :
                null
            }

            <div className="isoLoginForm">
              <Form onSubmit={this.handleSubmit} className="loginForm">
                <Row gutter={20}>
                  <Col md={24}>
                    <FormItem label={<Translate id={"label.email"} />}>
                      {getFieldDecorator("email", {
                        rules: [
                          {
                            type: "email",
                            message: <Translate id={"form.emailValid"} />
                          },
                          {
                            required: true,
                            message: <Translate id={"form.requiredMessage"} />
                          }
                        ]
                      })(
                        <Input
                          type="text"
                          size="large"
                          name="email"
                          id="email"
                        />
                      )}
                    </FormItem>
                    <FormItem label={<Translate id={"label.password"} />}>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: <Translate id={"form.requiredMessage"} />
                          }
                        ]
                      })(
                        <Input
                          type="password"
                          size="large"
                          name="password"
                          id="password"
                        />
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <div className="isoInputWrapper" style={{ height: "36px" }}>
                  <Link to="/recover-password" className="isoForgotPass">
                    <Translate id={"page.loginForgotPass"} />
                  </Link>
                </div>
                <div className="isoInputWrapper isoLoginBtn">
                  <Button
                    htmlType="submit"
                    className="default"
                    loading={loading}
                  >
                    <Translate id={"page.loginButton"} />
                  </Button>
                </div>
              </Form>
            </div>
            <Button onClick={this.loginWithMobileBankID} className="primary">
              <Translate id={"page.loginWithMobileBankID"} />
            </Button>

          </div>
        </div>
        <div className="login-image"></div>
      </LoginStyleWrapper>
    );
  }
}

const WrappedLoginForm = Form.create()(Login);

const mapStateToProps = function (state) {
  return {
    isLoggedIn: state.Auth.idToken
  };
};

/* const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions returned by action creators
    login: () => dispatch(login()),
    loginAction: () => dispatch(loginAction())
  }
} */
const mapDispatchToProps = {
  login: login,
  loginAction: loginAction,
  get_user: get_user
};

/* export default connect(
  state => ({
    isLoggedIn: state.Auth.idToken !== null ? true : false
  }),
  { login, loginAction }
)(WrappedLoginForm); */
export default connect(mapStateToProps, mapDispatchToProps)(WrappedLoginForm);
